module.exports = __webpack_public_path__ + "img/0.4b22b8ce.png";